export const SET_DATA_PIN_CODES = "SET_DATA_PIN_CODES";

export const setDataPinCodes = (data) => dispatch => {
  dispatch({
    type: SET_DATA_PIN_CODES,
    data
  });
};



// WEBPACK FOOTER //
// ./src/actions/pinCodes.js